import {app} from './app'
import {createI18n} from 'vue-i18n'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'bootstrap-icons/font/bootstrap-icons.css'


import {
    getAxiosInstance, getI18nInstance,
    getRouteInstance,
    getStoreInstance,
    initAxios, initI18n,
    initRouter,
    initStore
} from "@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance";

initAxios(store, router)
let axios = getAxiosInstance()

initStore(store)
let newStore = getStoreInstance()

initRouter(router)
let newRouter = getRouteInstance()


// ..
AOS.init();

export const apiBaseUrl = 'https://pbapi.mixitweb.com'
export const builderBaseUrl = 'https://pbapi.mixitweb.com/api'


// builderBaseUrl on main.js and axios.js must be: https://pbapi.mixitweb.com/api
// apiBaseUrl = 'https://pbapi.mixitweb.com';


import '@moeinmdn/miw-alpha-components/src/package/IndexComponent'

import iframeResize from 'iframe-resizer/js/iframeResizer';

app.directive('resize', {
    mounted(el) {
        iFrameResize({log: false}, el)
    },
})


window.addEventListener('storageChange', function () {
    // Handle the localStorage change here

    if (require('@/../package.json').name == 'miw-alpha') {
        let url = localStorage.getItem('projectDomain');
        axios.defaults.baseURL = url
    }
});

// import main requirements
import '@moeinmdn/mixitweb-front-modules/src/plugin/class/MainRequirementsV3'

require('bootstrap')
// import i18n
import {messages} from '@moeinmdn/miw-alpha-components/src/package/Translate/Original'

export const i18n = createI18n({
    locale: 'originalLanguage',
    fallbackLocale: 'originalLanguage',
    messages
})

initI18n(i18n)

import {deleteCookie, getCookie} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Authentication'

const attemptLogin = async () => {
    let token = localStorage.getItem('token')
    let cookieToken = getCookie('token');
    if (cookieToken != '' && token == null) {
        token = cookieToken;
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    }

    if (token === null) {
        return
    }
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    try {
        let res = await axios.get(`${builderBaseUrl}/auth/me`)
        const profile = res.data.data
        // axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        await newStore.dispatch('User/setToken', token)
        await newStore.dispatch('User/setProfile', profile)
    } catch (e) {
        localStorage.removeItem('token')
        deleteCookie('token')
        await newStore.dispatch('User/setToken', null)
        await newStore.dispatch('User/setProfile', null)
        return e
    }

}


attemptLogin().then(async (res) => {
    await newStore.dispatch('SiteInfo/getSiteInfos')
    app.use(newStore).use(i18n).use(newRouter).mount('#app')
}).catch(err => {
    app.use(newStore).use(i18n).use(newRouter).mount('#app')
})

